"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceUnavailableError = void 0;
const BaseError_1 = require("./BaseError");
class ServiceUnavailableError extends BaseError_1.BaseError {
    /** Sent as the `Retry-After` response header when set. */
    retryAfterSeconds;
    constructor(description = "Service Temporarily Unavailable", options) {
        super("ServiceUnavailableError", 503, description, true);
        this.retryAfterSeconds = options?.retryAfterSeconds;
    }
}
exports.ServiceUnavailableError = ServiceUnavailableError;
